@if (sessionModalService.isOpen()) {
<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" appPreventScroll>
    <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-300">
        <div class="p-6 sm:p-8 flex flex-col items-center text-center gap-6">
            <!-- Icon -->
            <div class="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="none" class="w-8 h-8 text-amber-500" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V12L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
                </svg>
            </div>

            <!-- Content -->
            <div class="flex flex-col gap-2">
                <h3 class="text-xl font-bold text-gray-900">{{ 'MODALS.SESSION.EXPIRING_TITLE' | translate }}</h3>
                <p class="text-gray-600 leading-relaxed">
                    {{ sessionModalService.message() }}
                </p>
            </div>

            <!-- Action -->
            <button (click)="closeModal()"
                class="w-full py-3 px-6 bg-[var(--color-primary)] hover:bg-black text-white font-semibold rounded-xl transition duration-300 ease-in-out transform active:scale-[0.98]">
                {{ 'MODALS.SESSION.CLOSE_BUTTON' | translate }}
            </button>
        </div>
    </div>
</div>
}